
.landing {
  text-align: center;
  width: 100%;
  font-family: Playfair Display, sans-serif;
  font-weight: 500;
  position: relative;
}

.svgWrapper {
  height: 18px;
  width: 25px;
}

.svgWrapper svg {
  height: 18px;
  padding-right: 6px;
  width: auto;
}

.landing .name {
  font-size: 50px;
  color: white;
  font-family: 'Playfair Display', sans-serif;
  white-space: nowrap;
}

h1, h2 {
  margin: 0;
}

.landing .subtitle {
  font-size: 40px;
  color: white;
  font-weight: 300;
  font-family: 'Playfair Display', sans-serif;
  white-space: nowrap;
}

@keyframes scrollWheel {
  0% {
    opacity:1;
    transform: translateY(40%);
  }
  100% {
    opacity:.7;
    transform: translateY(130%);
  }
}

@keyframes scrollText {
  0% {
    opacity: 1;
    transform: translateY(120%);
  }
  100% {
    opacity: .0;
    transform: translateY(180%);
  }
}

.open-app-button {
  line-height: 130%;
  letter-spacing: -.5px;
  box-sizing: border-box;
  text-decoration: unset;
  font-family: 'Playfair Display', sans-serif;
  background: black;
  color: #f1f1f1;
  box-shadow: 0 0px 23.84px 8.16px #3eb5f163;
  cursor: pointer;
  border: none;
  border-radius: 29px;
  outline: none;
  justify-content: center;
  align-items: center;
  padding: 12px 18px;
  font-size: 18px;
  font-weight: 500;
  transition: box-shadow .3s ease-out;
  display: flex;
  width: 160px;
  margin: 32px auto 0;
}

.open-app-button:hover {
  box-shadow: 0 3px 9.84px -0.84px #3eb5f12e;
}

.privacy {
  letter-spacing: 0;
  font-weight: 200;
  line-height: 15px;
  color: rgba(255, 255, 255, 0.527);
  white-space: nowrap;
  font-family: 'IBM Plex Sans'!important;

  a {
    font-size: 15px;
    color: inherit;
    text-decoration: none;
  }
}

.made-by {
  letter-spacing: 0;
  font-size: 14px;
  font-weight: 200;
  line-height: 14px;
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.527);
  font-family: 'IBM Plex Sans'!important;

  span {
    margin-right: 2px;
  }

  a {
    font-size: 20px;
    color: inherit;
    text-decoration: none;
    font-family: "Dancing Script";
  }
}

.icons {
  font-size: 15px;
  display: flex;
  gap: 22px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  position: absolute;
  right: 10px;
  bottom: 10px;
}

@media only screen and (max-width: 843px) {
  .landing .text {
    gap: 4px
  }

  .landing .name {
    font-size: 42px;
  }
  .landing .subtitle {
    font-size: 33px;
  }
}

@media only screen and (max-width: 640px) {
  .landing .text {
    gap: 4px;
  }

  .landing .name {
    font-size: 37px;
    white-space: normal;
    margin-bottom: 14px;
  }

  .landing .subtitle {
    font-size: 23px;
    white-space: normal;
  }

  .icons {
    display: none;
  }
}

.icon {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #0066ff;
  color: #fff;
  position: relative;
  z-index: 101;
}

.bg {
  background-image: url('./bg-dark.jpg');
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100vh;
  position: absolute;
  filter: brightness(60%);
}

.content {
  width: calc(100% - 20px);
  position: absolute;
  top: 80;
  left: 50%;
  transform: translateX(-50%);
}